<template>
  <div class="bg-image">
  <div class="manage-booking container" v-if="show">
    <booking-summary
      v-if="booking"
      :booking="booking"
      :isOrganizationEducation="isOrganizationEducation"
      :redirectUrl="redirectUrl"
      :analyticsPixelUrl="analyticsPixelUrlConfirm"
      :darkMode="widget.darkMode"
      @cancelBooking="cancelBooking"
      @redirectBack="redirectBack"
    />
    <div v-else class="no-booking">
      <h1>{{ $t("Look's like there's no reservation here.") }}</h1>
    </div>
  </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import BookingSummary from '../BookingSummary';

@Component({
  props: {
    customerId: {
      type: String,
      required: true,
    },
    bookingId: {
      type: String,
      required: true,
    },
  },
  components: {
    BookingSummary,
  },
})
export default class ManageBooking extends Vue {
  show = false;
  redirectUrl = null;
  refreshInterval = null;

  get booking () {
    return this.$store.getters['entities/Booking'](this.bookingId);
  }

  get analyticsPixelUrlConfirm () {
    if (this.$store.state.public.settings?.widget?.analyticsPixelUrlConfirm) {
      return this.$store.state.public.settings.widget.analyticsPixelUrlConfirm;
    }
  }

  get isOrganizationEducation () {
    if (this.$store.state.public.settings?.widget) {
      return this.$store.state.public.settings.widget.organization.type === 'education';
    }
  }

  get widget () {
    return this.$store.state.public.settings.widget;
  }

  async mounted () {
    try {
      const { paymentStatus } = await this.$store.dispatch('getBooking', {
        customerId: this.customerId,
        bookingId: this.bookingId,
      });

      if (paymentStatus === 'initiated') {
        this.refreshInterval = setInterval(async () => {
          await this.refreshBooking();
        }, 5000);
      }

      if (!this.$store.state.public.settings.widget) {
        await this.$store.dispatch('getWidget', { widgetId: this.booking.sourceableId });
      }
      this.redirectUrl = this.$store.state.public.settings.widget.redirectUrl;
    } finally {
      this.show = true;
    }
  }

  beforeDestroy () {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  async refreshBooking () {
    const { booking } = await this.$store.dispatch('getBooking', {
      customerId: this.customerId,
      bookingId: this.bookingId,
    });

    if (booking?.paymentStatus === 'completed' && this.booking?.paymentStatus !== 'completed') {
      this.$store.dispatch('insertEntities', { name: 'Booking', payload: booking });
      this.$store.dispatch('insertEntities', { name: 'Booking', payload: { ...booking, _waitForRefresh: false } });

      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    }
  }

  cancelBooking () {
    this.$store.commit('setConfirm', {
      message: this.$t('Are you sure you would like to cancel this reservation?'),
      buttons: [
        {
          name: this.$t('No'),
          type: 'cancel',
        },
        {
          name: this.$t('Yes'),
          action: () => {
            this.$store.dispatch('deleteBooking', { customerId: '1', bookingId: this.bookingId }).then(() => {
              this.$store.commit('setFlash', {
                message: this.$t('Cancelled Booking'),
                type: 'success',
              });
            });
          },
        },
      ],
    });
  }

  async redirectBack () {
    let url = this.redirectUrl;
    if (url.substring(0, 4) !== 'http') {
      url = `https://${url}`;
    }
    location.replace(url);
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.manage-booking {
  max-width: 80rem;
  margin-top: 6em;
}

.container {
  padding: 0 1.5rem;
  width: 100%;
  border-width: 2cm;
  border-color: white;
}

.bg-image {
  background-color: #1F1E1E;
  padding-left: 25%;
  padding-right: 25%;
  padding-bottom: 10%;
  left: 0;
  right: 0;
  position: absolute;
  overflow: hidden;
}
</style>
